var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#535353"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9987 16.6832C27.9789 16.6832 24.6175 19.5248 23.8552 23.3713C23.1621 23.0941 22.3997 22.9554 21.6373 22.9901C18.8651 23.1287 16.7166 25.4505 16.7166 28.3267C16.7166 31.099 18.969 33.3515 21.7413 33.3515C22.1918 33.3515 22.573 32.9703 22.573 32.5198C22.573 32.0693 22.1918 31.6881 21.7413 31.6881C19.87 31.6881 18.3799 30.1634 18.3799 28.3267C18.3799 26.3861 19.87 24.7228 21.7413 24.6535C22.6076 24.6188 23.4047 24.8614 24.0631 25.3812C24.3057 25.5891 24.6522 25.6238 24.9294 25.4851C25.2067 25.3465 25.4146 25.0693 25.4146 24.7574C25.5532 21.1881 28.4641 18.3812 32.068 18.3812C35.7413 18.3812 38.7215 21.3614 38.7215 25.0347V25.5891C38.6522 28.9851 35.8799 31.7228 32.4839 31.7228C32.0334 31.7228 31.6522 32.104 31.6522 32.5545C31.6522 33.0049 32.0334 33.3861 32.4839 33.3861C36.8502 33.3861 40.3849 29.8515 40.3849 25.4851V25.4158V25.0693C40.3156 20.4257 36.573 16.6832 31.9987 16.6832Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9817 30.7178C27.6698 30.4059 27.1153 30.4059 26.8034 30.7178L21.4322 36.0891C21.1203 36.401 21.1203 36.9554 21.4322 37.2673C21.744 37.5792 22.2985 37.5792 22.6104 37.2673L26.5609 33.3168V39.4851C26.5609 39.9356 26.9421 40.3168 27.3925 40.3168C27.843 40.3168 28.2242 39.9356 28.2242 39.4851V33.3168L32.1747 37.2673C32.348 37.4406 32.5559 37.5099 32.7638 37.5099C32.9718 37.5099 33.1797 37.4406 33.3529 37.2673C33.6648 36.9554 33.6648 36.401 33.3529 36.0891L27.9817 30.7178Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.8df5188b3c73adcb169b3f2af9f97ee3.svg";
export { ForwardRef as ReactComponent };